/* app/ui/sticky-subnav/sticky-subnav */

define(
	'app/ui/sticky-subnav/sticky-subnav',[
		'jquery',
		'util/mediaqueries',
		'app/ui/nav/sticky',
		'pubsub'
	],
	function ($, MediaQueries) {

		var selectors = {
			trigger: '.js-subnav__sticky-trigger',
			subNavContainer: '.js-sub-navigation-wrap',
			subNav: '.js-sub-navigation',
			mobileSubNavToggleText: '.js-sticky-subnav-toggle-text',
			mobileSubNavItemLink: '.js-sticky-subnav__item-link',
		};
		var classes = {
			isSticky: 'is-sticky__subnav'
		};

		var $window;
		var $trigger;
		var $subNav;
		var $subNavContainer;
		var $mobileSubNavItemLink;
		var $mobileSubNavBtn;
		var $mobileSubNavWrap;

		var module = {
			init: function () {
				module._initElements();
				if ($subNav.length) {
					module._initEvents();
				}
			},

			_initElements: function () {
				$subNav = $(selectors.subNav);
				$trigger = $(selectors.trigger);
				$subNavContainer = $(selectors.subNavContainer);
				$mobileSubNavToggleText = $(selectors.mobileSubNavToggleText);
				$mobileSubNavItemLink = $(selectors.mobileSubNavItemLink);
				$mobileSubNavBtn = $(".js-sticky-subnav-toggle");
				$mobileSubNavWrap = $(".js-sticky-subnav-expand");
				$mobileSubNavBtnIcon = $(".js-sticky-subnav-toggle-icon");
				$window = $(window);


				subNavHeight = $subNavContainer.height();
				// update sub nav container height
				$subNavContainer.height(subNavHeight);
			},

			_initEvents: function () {
				$.subscribe('/window/scroll', module._setStickiness);
				$mobileSubNavItemLink.on("click", module._subNavLinkClickHandler);
			},

			_setStickiness: function () {
				var stickySubNavOffSet = $trigger.offset().top;
				var scrollTop;
				var shouldBeSticky;

				scrollTop = $window.scrollTop();
				shouldBeSticky = scrollTop >= stickySubNavOffSet;

				if (shouldBeSticky) {
					$subNav.addClass(classes.isSticky);
				} else {
					$subNav.removeClass(classes.isSticky);
				}

			},

			_subNavLinkClickHandler: function (e) {
				var linkText = $(this).text().trim();
				var link = $(this).attr("href");


				$mobileSubNavToggleText.text(linkText);

				$mobileSubNavBtn.attr("aria-expanded", false);
				$mobileSubNavWrap.attr("aria-expanded", false);
				$mobileSubNavBtn.attr("aria-pressed", false);
			}
		};

		return {
			init: module.init
		};
	}
);
